var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScraperapiIllustration4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 162 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.198 157.346c-20.217-11.751-53.05-11.751-73.44 0-20.304 11.75-20.476 30.758-.259 42.508 20.218 11.751 53.05 11.751 73.44 0 20.391-11.664 20.477-30.758.259-42.508Z",
    fill: "#083489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.454 169.442c0-.26 0-.519.087-.778V159.333v.864c0 .259 0 .518-.087.777 0 .26-.086.432-.086.692 0 .259-.086.518-.086.777s-.087.432-.173.691c-.087.26-.087.519-.173.778s-.173.432-.173.691l-.259.778c-.086.259-.173.432-.259.691-.087.259-.173.518-.346.778a2.595 2.595 0 0 1-.345.691c-.087.259-.26.518-.346.777-.086.173-.259.432-.346.605-.172.259-.345.605-.518.864a2.608 2.608 0 0 1-.432.605c-.173.259-.432.605-.605.864s-.345.518-.518.691l-.259.259c-.346.432-.605.778-1.037 1.124l-.173.172c-.346.346-.605.692-.95 1.037l-.26.259c-.259.26-.518.519-.777.692-.173.172-.432.345-.605.604-.259.26-.518.432-.864.692-.259.172-.432.345-.691.518-.259.259-.605.432-.951.691-.259.173-.432.346-.691.519-.345.259-.691.432-1.037.691-.259.173-.432.259-.691.432-.605.345-1.209.777-1.814 1.123-.778.432-1.642.95-2.506 1.296-.259.086-.432.259-.691.346-.691.345-1.469.691-2.16 1.036l-.518.26c-.864.345-1.815.777-2.679 1.036-.259.087-.432.173-.691.26-.778.259-1.469.518-2.246.777l-.778.259c-.346.087-.778.26-1.123.346-.346.086-.778.259-1.123.346-.346.086-.778.172-1.124.259-.345.086-.777.173-1.209.259-.346.086-.778.173-1.124.259-.431.087-.777.173-1.21.259-.431.087-.777.173-1.209.26-.345.086-.777.172-1.123.172-.95.173-1.9.346-2.938.432h-.086c-.95.173-1.9.26-2.851.346-.346 0-.691.086-1.037.086-.518.087-1.123.087-1.642.173-.345 0-.69.087-1.036.087-.519 0-1.124.086-1.642.086-.346 0-.691 0-1.123.086H78.022c-.432 0-.864 0-1.296-.086-.432 0-.777 0-1.21-.086-.431 0-.863-.087-1.295-.087-.432 0-.778-.086-1.21-.086-.432 0-.864-.087-1.296-.087-.432 0-.778-.086-1.21-.086-.431-.086-.864-.086-1.295-.173-.346-.086-.778-.086-1.124-.173-.518-.086-1.037-.172-1.641-.259-.26-.086-.605-.086-.864-.173-.692-.086-1.296-.259-1.901-.345-.173 0-.346-.087-.519-.087-.864-.172-1.727-.345-2.592-.604-.259-.087-.518-.173-.777-.173-.605-.173-1.21-.259-1.728-.432l-.778-.259c-.777-.26-1.555-.432-2.246-.692a5.778 5.778 0 0 1-.691-.259c-.95-.345-1.815-.605-2.765-.95-.432-.173-.778-.346-1.123-.432-.26-.087-.605-.259-.864-.346-.432-.173-.778-.345-1.21-.518-.26-.087-.518-.259-.864-.346-.432-.173-.864-.432-1.296-.691-.26-.086-.432-.259-.691-.346-.605-.345-1.296-.691-1.9-1.036-10.023-5.876-15.035-13.479-15.12-21.082v8.467c0 7.603 5.01 15.293 15.12 21.082.604.345 1.295.691 1.9 1.037.26.086.432.259.691.345.432.259.864.432 1.296.691.26.087.518.26.778.346.432.173.777.346 1.21.518.258.087.604.26.863.346.346.173.691.259 1.037.432h.087c.864.346 1.814.691 2.764.95.26.087.432.173.691.26.778.259 1.47.432 2.247.691.173.086.345.086.432.173.086 0 .173.086.346.086.604.173 1.123.346 1.727.432.26.086.519.173.778.173.864.173 1.728.432 2.592.605.173 0 .346.086.518.086.605.086 1.296.259 1.988.346.259.086.605.086.95.172l1.555.26h.173c.346.086.605.086.95.086.432.086.864.086 1.296.173.346 0 .778.086 1.124.086.432 0 .864.087 1.296.087h.259c.346 0 .605 0 .95.086.432 0 .864.086 1.296.086.432 0 .778 0 1.21.087.432 0 .864 0 1.296.086h6.134c.519 0 1.124-.086 1.642-.086.346 0 .691-.087 1.037-.087.518 0 1.123-.086 1.641-.172.26 0 .432 0 .692-.087h.345c.95-.086 1.9-.173 2.851-.345h.087c.95-.173 1.9-.26 2.937-.432.087 0 .173 0 .346-.087.26-.086.518-.086.778-.173.431-.086.777-.172 1.21-.259.431-.086.777-.173 1.209-.259.432-.086.777-.173 1.209-.259.432-.087.778-.173 1.21-.259.346-.087.778-.173 1.123-.26.346-.086.778-.259 1.123-.345.346-.087.778-.259 1.124-.346.086 0 .259-.086.345-.086.173-.087.259-.087.432-.173.778-.259 1.469-.518 2.247-.778.259-.086.432-.172.691-.259.95-.345 1.814-.691 2.678-1.037l.519-.259c.777-.345 1.468-.691 2.16-1.037.259-.086.432-.259.691-.345.864-.432 1.641-.864 2.505-1.296.605-.346 1.21-.691 1.728-1.037h.087c.259-.173.432-.259.691-.432.346-.259.691-.432 1.037-.691.259-.173.432-.346.691-.519.346-.259.605-.432.95-.691.26-.173.432-.345.692-.518.259-.259.518-.432.864-.691.172-.173.432-.346.604-.605.173-.173.432-.346.605-.519l.173-.172.259-.26c.346-.345.691-.691.951-1.036l.172-.173c.346-.346.692-.778 1.037-1.123l.259-.26c.087-.086.173-.259.26-.345.086-.087.172-.259.259-.346.173-.259.432-.605.605-.864.172-.173.259-.432.432-.605.172-.259.345-.604.518-.864.086-.086.173-.259.259-.345.087-.087.087-.173.087-.259.172-.26.259-.519.345-.778.087-.259.259-.432.346-.691.086-.259.173-.519.345-.778.087-.173.173-.345.173-.432 0-.086.087-.173.087-.259l.259-.778c.086-.259.173-.432.173-.691.086-.259.086-.518.172-.777 0-.173.087-.346.087-.519v-.173c.086-.259.086-.518.086-.777.259-.259.259-.519.259-.691Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.067 138.251c20.304-11.75 53.223-11.75 73.44 0 20.218 11.751 20.131 30.759-.259 42.509-20.304 11.75-53.223 11.75-73.44 0-20.218-11.75-20.131-30.758.26-42.509Z",
    fill: "#E6EBF3",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74 157.173s4.32-2.679 5.01-2.938c.692-.173 6.999-3.024 13.651-1.209 6.653 1.814 8.9 5.011 8.554 7.948-.345 2.938-4.233 5.012-4.58 5.271-.345.259-7.257 4.147-7.257 4.147",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.576 161.32s-4.32 2.678-5.011 2.938c-.691.172-6.999 3.024-13.651 1.209-6.653-1.814-8.9-5.011-8.554-7.949.346-2.937 4.234-5.011 4.58-5.27.345-.259 7.257-4.147 7.257-4.147",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.54 149.051s-11.231 6.567-11.49 6.912c-.346.432-2.247 2.506.172 4.493 2.852 2.333 8.64 1.814 12.27-.605 3.542-2.505 10.54-5.702 15.033-1.209 2.851 2.851-3.715 5.961-3.715 5.961l-9.072 5.357",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.416 149.051c-1.555.864-4.147.951-5.703 0-1.555-.95-1.555-2.419 0-3.283 1.556-.95 4.148-.95 5.703 0 1.555.864 1.555 2.333 0 3.283ZM81.565 173.157c-1.555.864-4.147.95-5.703 0-1.555-.951-1.555-2.419 0-3.283 1.556-.951 4.148-.951 5.703 0 1.555.864 1.555 2.332 0 3.283Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72 127.797v13.392",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.486 86.757.087 35.251c0-4.925-1.987-9.763-5.703-14.083l-.086-35.251c3.715 4.32 5.702 9.158 5.702 14.083Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.486 86.757.087 35.251c0-4.925-1.987-9.763-5.703-14.083l-.086-35.251c3.715 4.32 5.702 9.158 5.702 14.083Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.486 86.757.087 35.251c0-4.925-1.987-9.763-5.703-14.083l-.086-35.251c3.715 4.32 5.702 9.158 5.702 14.083Z",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.95 120.28.087 35.251-2.592-3.715-.173-35.165 2.678 3.629ZM161.398 123.995c0-.691.087-1.296.087-1.987l-.087-35.251c-.604 19.181-22.118 29.549-38.361 33.523l.086 35.251c15.725-3.974 35.943-13.478 38.275-31.536Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.87 72.674 6.135-1.728c13.133 15.292 4.233 32.659-12.096 41.644-5.789 3.37-12.528 5.962-19.959 7.776l-2.678-3.628c6.566-1.642 12.614-3.975 17.712-6.912 14.602-8.122 22.55-23.588 10.886-37.152ZM13.05 94.1c6.22-7.602 14.688-11.922 24.191-15.033l-.086-35.251c-12.01 4.06-24.538 10.714-28.512 23.242-1.469 2.505-.346 36.892-.691 40.521 0-4.925 2.073-9.59 5.098-13.478Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.246 89.263.087 35.251-5.79 2.073-.172-35.25 5.875-2.075Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.126 107.579 1.04 72.414c0 6.826 3.37 13.392 9.331 19.008l.086 35.252c-5.961-5.703-9.33-12.269-9.33-19.095Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.371 91.336.086 35.251c-6.047-5.616-9.33-12.182-9.33-19.008L1.04 72.414c0 6.74 3.37 13.306 9.331 18.922Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.126 107.579 1.04 72.414c0 6.826 3.37 13.392 9.331 19.008l.086 35.252c-5.961-5.703-9.33-12.269-9.33-19.095Z",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.443 46.58c4.234-2.505 9.072-4.578 14.342-6.22l3.284 3.456C15.9 49.95-3.971 69.563 16.246 89.176l-5.875 2.074C-6.39 75.87 1.385 56.603 19.443 46.58Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.851 92.891v13.219M43.203 105.16v13.478M43.203 123.65v8.208M51.411 146.114v13.392M61.52 15.65v8.208M73.53.616v13.22M123.296 10.466v13.392M123.296 29.82v4.233M51.411 17.118V30.51",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.241 131.339v-12.701c-3.11 3.024-8.121 5.184-14.256 6.74v13.046c5.962-1.469 11.492-3.888 14.256-7.085Z",
    fill: "#1A22E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.093 119.762s3.11-1.383 5.702-3.716c2.679-2.419 3.543-4.147 3.543-4.147",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.093 119.762s3.11-1.383 5.702-3.716c2.679-2.419 3.543-4.147 3.543-4.147",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.093 124.427s3.11-1.382 5.702-3.715c2.679-2.419 3.543-4.147 3.543-4.147",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.093 124.427s3.11-1.382 5.702-3.715c2.679-2.419 3.543-4.147 3.543-4.147",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.093 129.006s3.11-1.382 5.702-3.715c2.679-2.419 3.543-4.147 3.543-4.147",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.093 129.006s3.11-1.382 5.702-3.715c2.679-2.419 3.543-4.147 3.543-4.147",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.485 68.526c2.246-24.71 28.425-47.865 52.963-35.856-2.247-1.123-6.653-3.628-8.986-4.406-11.232-4.147-24.105-.691-33.177 6.826-20.563 16.156-23.933 52.272 0 65.059l5.702 2.937c-11.232-5.702-18.23-19.526-16.502-34.56Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.723 29.474c19.267-1.383 33.782 14.774 32.486 35.942-1.382 21.168-18.057 39.485-37.41 40.781-19.268 1.382-33.783-14.775-32.487-35.943 1.382-21.168 18.144-39.398 37.411-40.78Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.662 72.242c.173-.605.432-1.124.691-1.642l.087-.086c.173-.26.26-.432.432-.691l10.368-15.12-3.456-3.025-10.368 15.12a1.881 1.881 0 0 0-.432.692v.086c-1.555 2.42-1.296 6.135.691 7.776l3.456 3.024c-1.555-1.382-2.16-3.715-1.469-6.134Z",
    fill: "#fff",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.326 54.703.432 16.588c.692 4.493-3.888 8.986-8.121 8.122-3.975-.519-5.444-5.53-3.197-8.9l.086-.086c.173-.259.26-.432.432-.69l10.368-15.034Z",
    fill: "#1A22E4",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.198 59.368-.777.26c.086.95.086 1.814.086 2.764 0 .26.173.432.432.346.173 0 .432-.26.432-.519 0-.864-.086-1.9-.173-2.851ZM60.57 63.342c-.26 1.47-.519 2.938-.605 4.493 0 .26.172.432.345.432.26 0 .432-.173.432-.432.087-1.469.346-2.937.605-4.32l-.778-.173Zm47.779-23.846-.605.691c5.27 4.234 8.813 10.887 9.59 18.663l.778-.26c-.778-8.035-4.406-14.774-9.763-19.094Zm-34.992 2.246c-6.048 5.184-10.714 12.528-12.528 20.736l.777.173c1.815-8.035 6.307-15.206 12.27-20.304l-.52-.605Zm17.798-7.69c-6.22.433-12.182 3.025-17.107 7.086l.518.604c9.159-7.69 23.242-9.59 32.746-2.073l.605-.691c-4.752-3.456-10.455-5.357-16.762-4.925Z",
    fill: "#465C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.533 62.22c-.173 0-.346.172-.432.345-.087.259.086.432.259.518.432.087 1.555.26 1.987.346l1.383.259h.086c.432 0 .605-.778.173-.864a275.414 275.414 0 0 1-3.456-.605ZM72.925 40.014c-.346 0-.519.519-.346.778.26.346.95 1.21 1.21 1.555l.864 1.123c.172.173.432.173.518 0a.532.532 0 0 0 .086-.604c-.345-.346-1.036-1.296-1.382-1.642-.26-.432-.691-1.296-.95-1.21ZM119.84 57.986c-1.037.259-2.506.777-3.542 1.123-.432.086-.432.864 0 .864h.086l1.037-.346c.518-.173 1.901-.605 2.419-.777.173-.087.346-.346.346-.519a.372.372 0 0 0-.346-.345ZM109.213 37.509c-.087 0-.259.086-.346.173-.345.432-1.296 1.555-1.728 1.987-.345.518-1.296 1.21-.864 1.555.173.173.432.086.519-.086.345-.432 1.123-1.296 1.468-1.728l1.21-1.21a.417.417 0 0 0 0-.605c-.086-.086-.173-.086-.259-.086Z",
    fill: "#465C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.317 57.035c-2.333.864-4.493 1.987-6.394 3.456-1.814 1.383-4.838 3.975-6.393 5.962M32.576 53.06a27.156 27.156 0 0 0-8.986 4.666c-1.728 1.297-3.024 2.679-4.06 3.889",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.576 76.82V62.134c-5.011 1.641-10.8 6.22-11.923 8.208l.086 12.441s7.863-4.665 11.837-5.961Z",
    fill: "#1A22E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.682 .184)",
    d: "M0 0h161.241v208.57H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScraperapiIllustration4);
export default __webpack_public_path__ + "static/media/scraperapi-illustration4.ea4127a7cd9dc9b476bc32b3b05e74a9.svg";
export { ForwardRef as ReactComponent };